export default __webpack_public_path__ + "static/media/tipo_de_usuarios.f9055d14.svg";